import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { LoginGuard } from 'src/app/components/core/_infrastructure/classes/guards/main.guard';
import { PvCamWrapperEditComponent } from './pvcam-wrapper-edit/pvcam-wrapper-edit.component';
import { AccessProgramaVerificacionGuard, ActionEstadoPvCamGuard } from '../_classes/access.guard';

const pvCamRoutes: Routes = [
    {
        path: 'campanias/programaverificacion/datosbasicos',
        data: {
            breadcrumb: 'Programas de Verificación',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION,
        },
        children: [
            {
                path: 'edit/:id',
                component: PvCamWrapperEditComponent,
                canActivate: [LoginGuard(), AccessProgramaVerificacionGuard(), ActionEstadoPvCamGuard()],
                data: {
                    breadcrumb: 'Detalle del Programa de Verificación',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(pvCamRoutes)],
    exports: [RouterModule],
})
export class PvCamRoutingModule {}
